module.exports = __webpack_public_path__ + "static/media/log-out-icon.37ff1076.svg";